<template>
  <div
    v-scroll="onScroll"
    class="v-gallery"
  >
    <v-filter />

    <v-container
      :fluid="!isScrolling"
      class="transition-swing"
    >
      <v-row
        :no-gutters="!isScrolling"
        class="transition-swing mx-n4"
      >
        <v-col
          v-for="(pic, i) in paginatedPictures"
          :key="pic.src"
          cols="12"
          md="4"
          class="transition-swing"
        >
          <photo-card
            :src="pic.thumb"
            @click.stop="setPicture(i)"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-responsive
      v-if="paginatedPictures.length < filteredPictures.length"
      class="py-12 mx-n3 text-center"
    >
      <v-btn
        text
        @click="page++"
      >
        Load More Works
      </v-btn>
    </v-responsive>

    <gallery-carousel v-model="dialog" />
  </div>
</template>

<script>
  // Utilities
  import {
    sync,
  } from 'vuex-pathify'

  export default {
    name: 'Gallery',

    components: {
      VFilter: () => import('@/components/Filter'),
      PhotoCard: () => import('@/components/PhotoCard'),
      GalleryCarousel: () => import('@/components/GalleryCarousel'),
    },

    props: { path: String },

    data: () => ({
      dialog: false,
      isScrolling: false,
      page: 1,
    }),

    computed: {
      ...sync('photographs', [
        'filter',
        'categories',
        'picture',
        'pictures',
      ]),
      filteredPictures () {
        return this.filter === 'All'
          ? this.pictures
          : this.pictures.filter(p => p.category === this.filter)
      },
      paginatedPictures () {
        return this.filteredPictures.slice(0, this.page * 12)
      },
    },
    created () {
      this.categories = [
        'All',
      ]
      this.pictures = []
      this.getPictures()
    },
    methods: {
      onScroll () {
        this.isScrolling = window.pageYOffset > 50
      },
      setPicture (index) {
        this.picture = index
        this.$nextTick(() => (this.dialog = true))
      },
      getPictures () {
        this.$http.get(this.$config.api + '/gallery/' + this.path + '/photos').then(response => {
          return response.json()
        }).then(jsonData => {
          jsonData.forEach((p, _) => {
            if (this.categories.indexOf(p.category) === -1) {
              this.categories.push(p.category)
            }
            this.pictures.push({
              src: `${this.$config.gallery}/${this.path}/${p.category}/${p.src}`,
              thumb: `${this.$config.gallery}/${this.path}/${p.category}/t/${p.src}`,
              category: p.category,
            })
          })
        })
      },
    },
  }
</script>

<style lang="sass">
  .gallery
    // max-width: 1280px
</style>
